 <template>
  <div>
    <label :for="id">{{ label }}</label>
    <div v-for="(v, index) in value" :key="v.id">
      <div class="form-group no-label mt-n1">
        <div class="input-group delete-addon">
          <input
            type="text"
            class="form-control"
            v-model="value[index].text"
            :placeholder="placeholder"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            @blur="validateRequired"
            required
            v-on:focus="$emit('focus')"
          />
          <div class="input-group-append">
            <span
              class="input-group-text clickable"
              @click="removeValue(index)"
              >{{ removeButtonLabel }}</span
            >
          </div>
          <div class="invalid-feedback">
            <span>{{ errorMessage }}</span>
          </div>
        </div>
      </div>
    </div>
    <a class="fa fa-plus-circle" @click="addValue"></a>
    <span class="ml-2">{{ addButtonLabel }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      idCounter: 0,
    };
  },
  methods: {
    addValue() {
      this.value.push({
        id: this.idCounter++,
        text: "",
      });
    },
    removeValue(index) {
      this.value.splice(index, 1);
    },
  },
  props: {
    // Id for do references for label
    id: {
      type: String,
      required: true,
    },
    // Text to show above component
    label: {
      type: String,
      required: true,
    },
    // Text to show inside input field as placeholder
    placeholder: {
      type: String,
      required: true,
    },
    // What value to actually bind to with use of v-model
    value: {
      type: Array,
      required: true,
    },
    // Text to represent error message when field is not filled out
    errorMessage: {
      type: String,
      required: true,
    },
    // Text for add button
    addButtonLabel: {
      type: String,
      required: true,
    },
    // Text for remove button
    removeButtonLabel: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/AppendList.vue